import { render, staticRenderFns } from "./Verifications.vue?vue&type=template&id=fd0477e6&"
import script from "./Verifications.vue?vue&type=script&lang=ts&"
export * from "./Verifications.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports